"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var dialog_store_1 = __importDefault(require("~/stores/dialog_store"));
var defaultDialogData = {
    title: "",
    description: "",
    btnList: [],
    show_time: 2000,
};
var Dialog = /** @class */ (function (_super) {
    __extends(Dialog, _super);
    function Dialog(props) {
        var _this = _super.call(this, props) || this;
        _this.componentDidMount = function () {
            dialog_store_1.default.setDialog(_this);
        };
        _this.showDialog = function (data) {
            _this.setState(__assign(__assign(__assign(__assign({}, _this.state), defaultDialogData), data), { show_state: true }));
            if (0 <= data.show_time) {
                setTimeout(function () { return _this.hideDialog(); }, data.show_time);
            }
        };
        _this.hideDialog = function () {
            _this.setState(__assign(__assign({}, _this.state), { show_state: false }));
        };
        _this.render = function () {
            var _a;
            var containerClassName = _this.state.customClassName
                ? "dialog-container ".concat(_this.state.customClassName, "-container")
                : 'dialog-container';
            return (react_1.default.createElement("div", { className: (_this.state.show_state) ? "dialog-wrapper active" : "dialog-wrapper" },
                react_1.default.createElement("div", { className: containerClassName },
                    react_1.default.createElement("h3", { className: "title" }, _this.state.title),
                    _this.state.description && react_1.default.createElement("p", { className: "text", dangerouslySetInnerHTML: { __html: _this.state.description } }),
                    react_1.default.createElement("div", { className: "btns" }, (_a = _this.state.btnList) === null || _a === void 0 ? void 0 : _a.map(function (object, index) { return react_1.default.createElement("button", { key: index, onClick: function () { return object.callback(); }, className: "btn " + object.customClass }, object.title); })))));
        };
        _this.state = {
            title: "",
            description: "",
            btnList: [],
            show_time: 2000,
            show_state: false,
        };
        return _this;
    }
    return Dialog;
}(react_1.default.Component));
exports.default = Dialog;
